import {parse} from 'query-string';

export const getSearchValues = search => {
  const query = parse(search);

  const page = typeof query.page === 'undefined' ? 0 : Number(query.page);

  const queryString = query.query;

  return {queryString, page};
};
